import { useNavigate } from "react-router-dom";
import { jsx as _jsx } from "react/jsx-runtime";
export let ButtonVariants = /*#__PURE__*/function (ButtonVariants) {
  ButtonVariants["primary"] = "primary";
  ButtonVariants["secondary"] = "secondary";
  ButtonVariants["outline"] = "outline";
  ButtonVariants["danger"] = "danger";
  ButtonVariants["outlineDanger"] = "danger-outline";
  return ButtonVariants;
}({});
function Button(_ref) {
  let {
    onClick,
    path,
    children,
    variant,
    disabled,
    styles,
    dataTrackEvent
  } = _ref;
  const navigate = useNavigate();
  const clickHandler = () => {
    if (onClick === undefined && path !== undefined) {
      navigate(path);
    }
    if (onClick) onClick();
  };
  return /*#__PURE__*/_jsx("button", {
    disabled: disabled,
    onClick: clickHandler,
    className: `base-btn ${variant} ${styles === null || styles === void 0 ? void 0 : styles.join(" ")}`,
    type: "button",
    "data-track-event": dataTrackEvent,
    children: children
  });
}
export default Button;